import { VueRenderer } from '@tiptap/vue-3';
import { EmojiIndex } from 'emoji-mart-vue-fast/src';
import data from 'emoji-mart-vue-fast/data/all.json';
import EmojiSearchList from '@/components/widgets/emojis/EmojiSearchList.vue';
import tippy from 'tippy.js';
import { getRectOrDestroy } from './util';

export default {
  emojis: new EmojiIndex(data),
  items: function ({ query }) {
    if (!query || typeof query !== 'string') {
      return {
        result: [
          this.emojis.emoji('+1'),
          this.emojis.emoji('smile'),
          this.emojis.emoji('rocket'),
          this.emojis.emoji('fire'),
          this.emojis.emoji('sparkles'),
        ],
        query: '',
      };
    }

    return {
      result: this.emojis.search(query, 20),
      query,
    };
  },
  render: () => {
    let component, popup;

    return {
      onStart: (props) => {
        component = new VueRenderer(EmojiSearchList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }
        popup = tippy('body', {
          getReferenceClientRect: getRectOrDestroy(props.clientRect, () => popup),
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
          maxWidth: '100%',
          role: 'poper',
        });
      },

      onUpdate(props) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: getRectOrDestroy(props.clientRect, () => popup),
        });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide();

          return true;
        }

        return component.ref?.onKeyDown(props);
      },

      onExit() {
        popup?.[0]?.destroy?.();
        component?.destroy?.();
      },
    };
  },
};
